import React, { useState, useEffect } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import PropTypes from "prop-types";
import { FluentTooltip } from "../../../../../../../components/FluentUI/Fluent-Tooltip";

/**
 * A Grid cell that, when not in edit mode, shows a tooltip on hover,
 * and when in edit mode, renders a ComboBox that mixes dropdown + inline.
 */
export const PropertyValueCell = (props) => {
  const { dataItem, field, list, onChange } = props;

  // all possible values (array of strings)
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [value, setValue] = useState("");

  useEffect(() => {
    const values = list.CustomPropertyValues || [];
    setAllData(values);
    setFilteredData(values);

    // initialize from the dataItem
    const initial = dataItem[field] ?? "";
    setValue(initial);
  }, [list.CustomPropertyValues, dataItem, field]);

  const filterChange = (e) => {
    setFilteredData(filterBy(allData, e.filter));
  };

  const handleChange = (e) => {
    const newVal = e.target.value;
    setValue(newVal);

    onChange({
      dataItem: dataItem,
      field: field,
      syntheticEvent: e.syntheticEvent,
      value: newVal,
    });
  };

  // When not editing, just show text with tooltip
  if (!dataItem.inEdit) {
    return (
      <FluentTooltip
        target={<td className="k-table-td">{value}</td>}
        text={value}
      />
    );
  }

  // In edit mode: hybrid dropdown + inline text
  return (
    <td className="k-table-td">
      <ComboBox
        data={filteredData}
        filterable={true}
        allowCustom={true}
        onFilterChange={filterChange}
        onChange={handleChange}
        value={value}
        style={{ width: "100%" }}
      />
    </td>
  );
};

PropertyValueCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  list: PropTypes.shape({
    CustomPropertyValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
